const STORAGE_KEY = 'usage_count';
const LIMIT_TIME_KEY = 'limit_hit_time';
const MAX_TRIES = 5;
const COOLDOWN_PERIOD = 59 * 1000; // 59 seconds

function getCount() {
  return parseInt(localStorage.getItem(STORAGE_KEY) || '0');
}

function saveCount(count) {
  localStorage.setItem(STORAGE_KEY, count.toString());
}

function getLimitTime() {
  const time = localStorage.getItem(LIMIT_TIME_KEY);
  return time ? parseInt(time) : null;
}

function setLimitTime() {
  localStorage.setItem(LIMIT_TIME_KEY, Date.now().toString());
}

function clearLimitTime() {
  localStorage.removeItem(LIMIT_TIME_KEY);
}

export function canMakeRequest() {
  const count = getCount();
  const limitTime = getLimitTime();
  
  // If we're in cooldown period
  if (limitTime) {
    const timeElapsed = Date.now() - limitTime;
    if (timeElapsed < COOLDOWN_PERIOD) {
      return {
        allowed: false,
        reason: 'cooldown',
        remainingTime: COOLDOWN_PERIOD - timeElapsed,
        requestsLeft: 0
      };
    }
    // Cooldown period is over
    clearLimitTime();
    saveCount(0);
    return {
      allowed: true,
      requestsLeft: MAX_TRIES
    };
  }

  // Not in cooldown, check count
  return {
    allowed: true,
    requestsLeft: MAX_TRIES - count
  };
}

export function recordRequest() {
  const count = getCount();
  const newCount = count + 1;
  saveCount(newCount);
  
  // Only set limit time if we've exceeded MAX_TRIES
  if (newCount > MAX_TRIES) {
    setLimitTime();
  }
}

export function recordAdView() {
  saveCount(0);
  clearLimitTime();
  return canMakeRequest();
}

export function forceResetAll() {
  saveCount(0);
  clearLimitTime();
  return canMakeRequest();
}
